<template>
  <ul class="sidebar-menu" data-widget="tree">
    <!-- <div class="sidebar-menu">
      <li class="header" v-if= "this.user1.roleName == 'Super Admin' || this.user1.roleName == 'Admin' || this.user1.roleName == 'Journey Manager' ||  this.user1.roleName == 'GA Head'">Transactional</li>
    
      <router-link
        tag="li"
        class="pageLink"
        to="/vehicle_status"
        v-if= "this.user1.roleName == 'Super Admin' || this.user1.roleName == 'Admin' || this.user1.roleName == 'Journey Manager' ||  this.user1.roleName == 'GA Head' "
      >
        <a>
          <i class="fa fa-truck"></i>
          <span class="page">Vehicles Status</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        class="pageLink"
        to="/routes"
        v-if= "this.user1.roleName == 'Super Admin' || this.user1.roleName == 'Admin' || this.user1.roleName == 'Journey Manager' ||  this.user1.roleName == 'GA Head' "
      >
        <a>
          <i class="fa fa-road"></i>
          <span class="page">Routes</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        class="pageLink"
        to="/trip"
        v-if= "this.user1.roleName == 'Super Admin' || this.user1.roleName == 'Admin' || this.user1.roleName == 'Journey Manager' ||  this.user1.roleName == 'GA Head'"
      >
        <a>
          <img src="/static/img/transport.png"/>
          <span class="page">Trips</span>
        </a>
      </router-link>

      <router-link
        tag="li"
        class="pageLink"
        to="/trip-group"
        v-if= "this.user1.roleName == 'Super Admin' || this.user1.roleName == 'Admin' || this.user1.roleName == 'Journey Manager' ||  this.user1.roleName == 'GA Head' "
      >
        <a>
          <i class="fa fa-truck"></i>
          <span class="page">Group Trip</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        class="pageLink"
        to="/hcvdetails"
        v-if= "this.user1.roleName == 'Super Admin' || this.user1.roleName == 'Admin' || this.user1.roleName == 'Journey Manager' ||  this.user1.roleName == 'GA Head'"
      >
        <a>
          <img src="/static/img/transport.png"/>
          <span class="page">HCV Status</span>
        </a>
      </router-link>

    </div> -->
    <div class="sidebar-menu">
      <li class="header" v-if="this.user1.roleName == 'Super Admin'">
        Masters</li>
      <router-link v-if="this.user1.roleName == 'Super Admin'" tag="li" class="pageLink" to="/users">
        <a>
          <i class="fa fa-user"></i>
          <span class="page">Users</span>
        </a>
      </router-link>
      <!-- <router-link tag="li" class="pageLink" to="/roles" v-if="this.user1.roleName == 'Super Admin'">
        <a>
          <i class="fa fa-id-card"></i>
          <span class="page">Roles</span>
        </a>
      </router-link>
      <router-link tag="li" class="pageLink" to="/location"
        v-if="this.user1.roleName == 'Super Admin' || this.user1.roleName == 'Admin' || this.user1.roleName == 'Journey Manager' || this.user1.roleName == 'GA Head' || this.user1.roleName == 'Sales Manager'">
        <a>
          <i class="fa fa-map-marker"></i>
          <span class="page">Locations</span>
        </a>
      </router-link>
      <router-link tag="li" class="pageLink" to="/device"
        v-if="this.user1.roleName == 'Super Admin' || this.user1.roleName == 'Admin' || this.user1.roleName == 'Journey Manager' || this.user1.roleName == 'GA Head' || this.user1.roleName == 'Sales Manager'">
        <a>
          <i class="fa fa-mobile" style="font-size: 20px"></i>
          <span class="page">Devices</span>
        </a>
      </router-link>
      <router-link tag="li" class="pageLink" to="/vehicle"
        v-if="this.user1.roleName == 'Super Admin' || this.user1.roleName == 'Admin' || this.user1.roleName == 'Journey Manager' || this.user1.roleName == 'GA Head'">
        <a>
          <i class="fa fa-truck"></i>
          <span class="page">Vehicles</span>
        </a>
      </router-link>
      <router-link tag="li" class="pageLink" to="/driver"
        v-if="this.user1.roleName == 'Super Admin' || this.user1.roleName == 'Admin' || this.user1.roleName == 'Journey Manager' || this.user1.roleName == 'GA Head'">
        <a>
          <i class="fa fa-id-card"></i>
          <span class="page">Drivers</span>
        </a>
      </router-link>
      <router-link tag="li" class="pageLink" to="/ga">
        <a>
          <i class="fa fa-map"></i>
          <span class="page">Geographical Areas</span>
        </a>
      </router-link> -->
    </div>
    <div class="sidebar-menu">
      <!-- <li class="header" v-if= "this.user1.roleName == 'Super Admin' || this.user1.roleName == 'Admin' || this.user1.roleName == 'Journey Manager' ||  this.user1.roleName == 'GA Head' ||  this.user1.roleName == 'Sales Manager' || this.user1.roleName == 'Sales Representative' || this.user1.roleName == 'Report Staff'">Report Section</li>
      <router-link
        tag="li"
        class="pageLink"
        to="/reports"
        v-if= "this.user1.roleName == 'Super Admin' || this.user1.roleName == 'Admin' || this.user1.roleName == 'Journey Manager' ||  this.user1.roleName == 'GA Head' ||  this.user1.roleName == 'Sales Manager' || this.user1.roleName == 'Report Staff'"
      >
        <a>
          <i class="fa fa-file"></i>
          <span class="page">Reports</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        class="pageLink"
        to="/report_settings"
        v-if= "this.user1.roleName == 'Super Admin' || this.user1.roleName == 'Admin' || this.user1.roleName == 'Journey Manager' ||  this.user1.roleName == 'GA Head' ||  this.user1.roleName == 'Sales Manager' || this.user1.roleName == 'Report Staff'"
      >
        <a>
          <i class="fa fa-book"></i>
          <span class="page">Report Schedules</span>
        </a>
      </router-link> -->
      <!-- <router-link
        tag="li"
        class="pageLink"
        to="/user_settings"
        v-permission.if="[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN]"
      >
        <a>
          <i class="fa fa-user"></i>
          <span class="page">User Settings</span>
        </a>
      </router-link> -->
      <!-- <router-link
        tag="li"
        class="pageLink"
        to="/sales_settings"
        v-if= "this.user1.roleName == 'Super Admin' || this.user1.roleName == 'Admin' || this.user1.roleName == 'Journey Manager' ||  this.user1.roleName == 'GA Head' ||  this.user1.roleName == 'Sales Manager' || this.user1.roleName == 'Sales Representative' || this.user1.roleName == 'Report Staff'"
      >
        <a>
          <i class="fa fa-shopping-cart"></i>
          <span class="page">Sales Status</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        class="pageLink"
        to="/operator_report"
         v-if= "this.user1.roleName == 'Super Admin' || this.user1.roleName == 'Admin' || this.user1.roleName == 'Journey Manager' ||  this.user1.roleName == 'GA Head' ||  this.user1.roleName == 'Sales Manager'"
      >
        <a>
          <i class="fa fa-file"></i>
          <span class="page">Operator Report</span>
        </a>
      </router-link>
      <router-link
        tag="li"
        class="pageLink"
        to="/complianceReport"
         v-if= "this.user1.roleName == 'Super Admin' || this.user1.roleName == 'Admin' || this.user1.roleName == 'Journey Manager' ||  this.user1.roleName == 'GA Head' ||  this.user1.roleName == 'Sales Manager'"
      >
        <a>
          <i class="fa fa-check-square-o"></i>
          <span class="page">Compliance Reports</span>
        </a>
      </router-link> -->
    </div>
  </ul>
</template>

<script>
import { USER_ROLES, EVENTS } from '../../../config';
import { eventBus } from '../../../services';
import { mapState } from 'vuex';
import { authService } from '../../../services'
export default {
  name: 'SidebarName',
  data() {
    return {
      role: '',
      USER_ROLES: USER_ROLES,
    };
    console.log("userrrr", this.user)
  },
  created() {
    this.user = this.$store.state.auth.user;
    this.role = this.$store.state.auth.user.roleName
      ? this.$store.state.auth.user.roleName.toUpperCase()
      : '';
  },
  computed: {
    ...mapState({
      user1: state => state.auth.user
    })
  }

};
</script>

<style lang="scss">
/* override default */
.sidebar-menu>li>a {
  padding: 12px 15px 12px 15px;
}

.sidebar-menu li.active>a>.fa-angle-left,
.sidebar-menu li.active>a>.pull-right-container>.fa-angle-left {
  animation-name: rotate;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-90deg);
  }
}
</style>


// WEBPACK FOOTER //
// SidebarMenu.vue?57950773